import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { from, Observable, of, switchMap, tap } from 'rxjs';
import { debugOffline } from '../common/constants';
import { STYLES_SUMMARY } from '../common/endpoints';
import { isOnline, LOCALLY_HOSTED } from '../common/setup';
import { RequestMethod } from '../model';
import { OfflineNavigationService } from './offline-navigation.service';


@Injectable()
export class LocalNavigationInterceptor implements HttpInterceptor {

    constructor(
        @Inject(forwardRef(() => OfflineNavigationService)) private offlineNavigationService: OfflineNavigationService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = req;
        if (!LOCALLY_HOSTED) {
            return next.handle(authReq);
        }
        if (req.params.get('skipInterceptor')) {
            const newParams = req.params.delete('skipInterceptor');
            const clonedReq = req.clone({ params: newParams });
            return next.handle(clonedReq);
        }
        if (req.method != RequestMethod.GET) {
            if (isOnline()) {
                return next.handle(authReq);
            }
            const { store, crudApi } = this.offlineNavigationService.getStoreByWriteApi(req);
            if (store) {
                return from(this.offlineNavigationService.saveRequest(req, store.name, crudApi)).pipe(
                    switchMap(dbObject => of(new HttpResponse({ body: dbObject, status: crudApi.responseStatus })))
                );
            } else {
                return next.handle(authReq);
            }
        }
        if (req.url.endsWith(STYLES_SUMMARY)) { // saved in local storage
            return next.handle(authReq);
        }
        if (isOnline()) {
            return next.handle(req).pipe(
                tap((event) => {
                    if (!this.offlineNavigationService.getStoreFromApi(req) && event instanceof HttpResponse) {
                        this.offlineNavigationService.saveWithRetry(req.urlWithParams, event.body);
                    }
                })
            );
        } else {
            debugOffline(`Trying to retrieve offline: ${req.urlWithParams}`);
            return from(this.offlineNavigationService.getWithRetry(req)).pipe(
                switchMap(dbObject => {
                    debugOffline(`Offline response: ${JSON.stringify(dbObject)}`);
                    return of(new HttpResponse({ body: dbObject, status: 200 }))
                })
            );
        }
    }
}

export const localNavigationInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: LocalNavigationInterceptor, multi: true }
];